$(document).ready(function(){$(".ColorSwatch.ColorSwatch--small").each(function(){if($(this).css('backgroundColor').trim()){var d=$('<span/>').css('backgroundColor','white').css('backgroundColor',$(this).css('backgroundColor'));if(d.css('backgroundColor')!='white'&&d.css('backgroundColor')!='rgb(255, 255, 255)'&&d.css('backgroundColor')!='rgba(0, 0, 0, 0)'){$(this).css('backgroundImage','none')}else{$(this).css('backgroundColor','none')}}});
//$(".english_description").show();$(".chinese_description").hide();var currLanguage=Weglot.getCurrentLang();if(currLanguage=='en'){$(".english_description").show();$(".chinese_description").hide()}else if(currLanguage=='zh'){$(".english_description").hide();$(".chinese_description").show()}
//Weglot.on("languageChanged",function(newLang,prevLang){if(newLang=='zh'){jQuery(".english_description").hide();jQuery(".chinese_description").show()}else if(newLang=='en'){$(".english_description").show();$(".chinese_description").hide()}})
});

var coll = document.getElementsByClassName("question");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function(e) {
    e.preventDefault();
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
      this.innerHTML = this.innerHTML.replace("<span id=\"expander\">-</span> ", "<span id=\"expander\">+</span> ");
    } else {
      var coll2 = document.getElementsByClassName("question");
      var i2;
      for (i2 = 0; i2 < coll2.length; i2++) {
        coll2[i2].innerHTML = coll2[i2].innerHTML.replace("<span id=\"expander\">-</span> ", "<span id=\"expander\">+</span> ");
      }
      content.style.display = "block";
      this.innerHTML = this.innerHTML.replace("<span id=\"expander\">+</span> ", "<span id=\"expander\">-</span> ");
    }
    var notthis = $('.active').not(this);
    notthis.toggleClass('active').next('.answer').slideToggle(300);
  });
};